export default __webpack_public_path__ + "static/media/ulm_light.2ec19096.png";